export type NotificationStatus = "important" | "none";

export type Notification = {
  id: number;
  title: string;
  content: string;
  flagType: NotificationStatus;
  postedAt: string;
};

export type Notifications = Notification[];

export const notificationsDefaultValues: Notifications = [];
